import { store } from '@/store';

const unsplashObjectByImgSrc = (url, name = '') => {
  const unsplashId = url ? url.substring(url.indexOf('.com/') + 5, url.lastIndexOf('?')) : '';
  const img = {
    id: `unsplash-${unsplashId}`,
    name: name,
    team_id: store.getters.getTeamID,
    time_created: Math.floor(Date.now() / 1000),
    type: 'image/jpg',
    url,
    user_id: store.getters.getUser.id,
  };
  return img;
};

const objectByImgSrc = (id, url, name = '') => {
  return {
    id,
    name,
    team_id: store.getters.getTeamID,
    time_created: Math.floor(Date.now() / 1000),
    type: 'image/jpg',
    url,
    user_id: store.getters.getUser.id,
  };
};

export { unsplashObjectByImgSrc, objectByImgSrc };
